<!-- eslint-disable vue/no-mutating-props -->
<template>
    <v-container fluid>
        <AddErrorDialog :is-open="isAddErrorDialogVisible" @on-close="handleCloseAddErrorDialog" />
        <v-row>
            <v-col cols="9">
                <v-textarea
                    v-model="complaint.discrepancyCause"
                    label="Przyczyna niezgodności"
                    outlined
                    no-resize
                    hide-details
                    :rows="4"
                    :disabled="isReadOnly"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="9">
                <v-autocomplete
                    v-model="complaint.responsiblePerson"
                    :items="responsibleUsers"
                    label="Osoby odpowiedzialne"
                    item-value="id"
                    :item-text="userFullName"
                    :no-data-text="responsibleUserSearchNoDataText"
                    clearable
                    multiple
                    chips
                    :loading="responsibleUserSearchData.isLoading"
                    :search-input.sync="responsibleUserSearchData.search"
                    :error="validationState.responsiblePerson.error"
                    :error-messages="validationState.responsiblePerson.messages"
                    :disabled="isReadOnly"
                    @blur="emitFieldBlur('responsiblePerson')"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3">
                <v-autocomplete
                    v-model="complaint.complaintErrorId"
                    :items="availableErrors"
                    :filter="customErrorFilter"
                    item-value="id"
                    no-data-text="Nie znaleziono opisu błędu"
                    label="Opis błędu"
                    :disabled="isReadOnly"
                >
                    <template slot="selection" slot-scope="data">
                        {{ data.item.name }}
                    </template>

                    <template slot="item" slot-scope="data">
                        {{ data.item.name }}
                    </template>
                    <template slot="append-outer">
                        <v-tooltip v-if="!isReadOnly" top :open-delay="tooltipDelay">
                            <template #activator="{on}">
                                <v-icon color="info" v-on="on" @click="handleShowAddErrorDialog">
                                    mdi-plus
                                </v-icon>
                            </template>
                            <span>Dodaj nowy</span>
                        </v-tooltip>
                    </template>
                </v-autocomplete>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import AddErrorDialog from '../../Dialogs/AddErrorDialog.vue'
import tooltipDelay from '@/mixins/tooltip'
import availableErrorsMixin from '@/mixins/availableErrors'

export default {
    name: 'CausesTab',

    components: {
        AddErrorDialog
    },

    mixins: [tooltipDelay, availableErrorsMixin],

    props: {
        complaint: {
            type: Object,
            default: null,
        },
        storeModuleName: {
            type: String,
            default: ''
        },
        validation: {
            type: Object,
            default: () => ({}),
        },
        isReadOnly: {
            type: Boolean,
        },
    },

    data() {
        return {
            // Flags
            isAddErrorDialogVisible: false,

            // Data for selects with searach
            responsibleUserSearchData: {
                isLoading: false,
                search: null,
                timer: null,
                lastQuery: null,
                debounceTimer: 300
            },
        }
    },

    computed: {
        validationState() {
            const defaults = {
                responsiblePerson: { error: false, messages: [] },
            }

            const provided = this.validation || {}
            const state = {}

            Object.keys(defaults).forEach(key => {
                const entry = provided[key] || {}

                state[key] = {
                    error: Boolean(entry.error),
                    messages: Array.isArray(entry.messages) ? entry.messages : []
                }
            })

            return state
        },

        /* Selects lists */
        responsibleUsers() {
            return this.$store.state.complaints.internalComplaints.responsibleUsers
        },
        errors() {
            return this.$store.state.complaints.internalComplaints.errors
        },

        /* Utils */
        userFullName() {
            return user => `${user.firstName || user.userFirstName} ${user.lastName || user.userLastName}`.trim()
        },

        responsibleUserSearchNoDataText() {
            if (this.responsibleUserSearchData.isLoading) return 'Szukanie...'

            const search = this.responsibleUserSearchData.search

            return !search || search.length < 3
                ? 'Wpisz conajmniej 3 znaki żeby wyszukać'
                : 'Nie znaleziono użytkowników'
        },
    },

    watch: {
        'responsibleUserSearchData.search'(value) {
            clearTimeout(this.responsibleUserSearchData.timer)
            this.responsibleUserSearchData.timer = setTimeout(async() => {
                const search = (value || '').trim()

                if (search.length < 3 || search === this.responsibleUserSearchData.lastQuery) return

                this.responsibleUserSearchData.isLoading = true
                await this.$store.dispatch(`${this.storeModuleName}/getUsers`, { search, type: 'responsibleUsers' })
                this.responsibleUserSearchData.lastQuery = search
                this.responsibleUserSearchData.isLoading = false
            }, this.responsibleUserSearchData.debounceTimer)
        }
    },

    methods: {
        emitFieldBlur(field) {
            this.$emit('field-blur', field)
        },

        customErrorFilter(item, queryText) {
            const error = item.name.toLowerCase(),
                search = queryText.toLowerCase()

            return error.indexOf(search) > -1
        },

        handleShowAddErrorDialog() {
            this.isAddErrorDialogVisible = true
        },

        handleCloseAddErrorDialog() {
            this.$store.dispatch(`${this.storeModuleName}/getErrors`),
            this.isAddErrorDialogVisible = false
        },
    }
}
</script>
